module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/promotions-post/promotion-post-grid/promotion-post-grid.component.css
// module id = ./src/app/hrms/Promotions/promotions-post/promotion-post-grid/promotion-post-grid.component.css
// module chunks = main